<template>
    <div class="page">
        <div class="page-bd max">
            <el-row>
                <el-col class="pd-10" :span="12">
                    <el-card>
                        <p slot="header">
                            <span class="f-red"><Icon type="md-flash" />{{$t('clear_com_redis')}}</span>
                        </p>
                        <div class="tright">
                            <el-button type="primary" @click="clearCache()">{{$t('clear')}}</el-button>
                        </div>
                    </el-card>
                </el-col>
                <el-col class="pd-10" :span="12">
                    <el-card>
                        <p slot="header">
                            <span class="f-red"><Icon type="md-flash" />{{$t('clear_com_setup_redis')}}</span>
                        </p>
                        <div class="tright">
                            <el-button type="primary" @click="clearComSetup()">{{$t('clear')}}</el-button>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name:'system-redis',
        components:{
        },
        data:function(){
            return{
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
        },
        methods:{
            clearCache() {
                this.$base.showLoading();
                this.$request.sendPost('redis/clear-com',{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.alertSuccess(error.errmsg)
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            clearComSetup() {
                this.$base.showLoading();
                this.$request.sendPost('redis/clear-com-setup',{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.alertSuccess(error.errmsg)
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/system/cache.vue